import React from "react";

function PlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="12"
      fill="none"
      viewBox="0 0 11 12"
    >
      <path
        fill="#DE2242"
        d="M10.805 5.941c0 .5-.4.9-.9.9h-3.6v3.4c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-3.4h-3.4c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h3.4v-3.6c0-.5.4-.9.9-.9s.9.4.9.9v3.6h3.6c.5 0 .9.4.9.9z"
      ></path>
    </svg>
  );
}

export default PlusIcon;
